module.exports = __webpack_public_path__ + "assets/img/returnBtn-b8428dd6.png";